import { render } from "./StatisticsSection.vue?vue&type=template&id=7e53f46e&scoped=true"
import script from "./StatisticsSection.vue?vue&type=script&lang=ts"
export * from "./StatisticsSection.vue?vue&type=script&lang=ts"

import "./StatisticsSection.vue?vue&type=style&index=0&id=7e53f46e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e53f46e"

export default script